export const SUPPORT_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
};
